import dayjs from 'dayjs'
import * as Yup from 'yup'

import { getUserSetting } from '@shared/hooks/src/useUserSetting'
import { UserSettingName } from '@shared/utils'

export const createValidationSchema = (formatMessage) => {
  return Yup.object().shape({
    nickname: Yup.string().trim(),
    firstName: Yup.string().trim().required(formatMessage('form.error.required')),
    lastName: Yup.string().trim().required(formatMessage('form.error.required')),
    phone: Yup.string().trim().min(10, formatMessage('form.phone.invalid')).max(10, formatMessage('form.phone.invalid')),
    email: Yup.string().trim().email(formatMessage('form.email.invalid')).max(255).required(formatMessage('form.error.required')),
    dob: Yup.lazy(() =>
      Yup.date()
        .min('1901-01-01', formatMessage('form.datepicker.validation.dateMin'))
        .max(dayjs().subtract(18, 'year'), formatMessage('form.dob.ageRestriction'))
        .nullable()
        .typeError(formatMessage('form.datepicker.validation.invalid'))
        .required(formatMessage('form.error.required'))
    ),
    pronouns: Yup.string(),
  })
}

export const getInitialValues = (user) => {
  return {
    nickname: user?.nickname ?? '',
    firstName: user?.firstName ?? '',
    lastName: user?.lastName ?? '',
    phone: user?.phone ?? '',
    email: user?.email ?? '',
    dob: user?.dob ? dayjs(user.dob) : null,
    pronouns: user?.pronouns ?? '',
  }
}

export const formikToApiData = (data) => {
  return {
    patient: {
      nickname: data.nickname,
      phone: data.phone,
      email: data.email,
      dob: data.dob.format('YYYY-MM-DD'),
      pronouns: data.pronouns || null,
    },
  }
}

export const getMissingInfo = (user, formatMessage) => {
  const values = getInitialValues(user)
  const emailVerifiedSetting = getUserSetting(user, UserSettingName.EmailVerified)
  const phoneVerifiedSetting = getUserSetting(user, UserSettingName.PhoneVerified)

  const errors = {}
  if (!values.firstName) {
    errors.firstName = formatMessage('profile.missing.firstName')
  }
  if (!values.lastName) {
    errors.lastName = formatMessage('profile.missing.lastName')
  }
  if (values.phone && !phoneVerifiedSetting?.value && !user?.smsOptOut) {
    errors.phoneVerification = formatMessage('profile.missing.phoneVerification')
  }
  if (!values.email) {
    errors.email = formatMessage('profile.missing.email')
  }
  if (values.email && !emailVerifiedSetting?.value) {
    errors.emailVerification = formatMessage('profile.missing.emailVerification')
  }
  if (!values.dob) {
    errors.dob = formatMessage('profile.missing.dob')
  }
  return errors
}
